const OptionTypeEnum = {
  Call: 'Call',
  Put : 'Put'
}

export default OptionTypeEnum
